import { Injectable } from "@angular/core";

// bfx
import { ActiveUserProfilePromiseService, ActiveUser } from "shared/cubiq-services";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
/*  */
export class BfxUserProfileService {
  /**********************************************************************/
  /* DATA */
  private primed: boolean = false;
  private primePromise: Promise<boolean>;
  private userData: ActiveUser = new ActiveUser();

  /**********************************************************************/
  /* CONSTRUCTOR */
  constructor(private userProfileService: ActiveUserProfilePromiseService) {
    logger.out.info("OMS BfxUserProfileService: init invoked");
    this.initialize();
  }

  /**********************************************************************/
  /* INITIALIZATION */
  private initialize(): void {
    this.primePromise = new Promise<boolean>((resolve, reject) => {
      if (this.primed) {
        resolve(true);
      } else {
        this.userProfileService.getActiveUserData().then(
          (_userData: ActiveUser) => {
            this.userData = _userData;
            this.primed = true;
            resolve(true);
          },
          (rjc) => {
            reject(rjc);
          },
        );
      }
    });
  }

  /**********************************************************************/
  /* PUBLIC METHODS */

  public getUserData(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      this.primePromise.then(
        (value: boolean) => {
          if (value) {
            resolve(this.userData);
          } else {
            resolve(false);
          }
        },
        (rjc) => {
          resolve(false);
        },
      );
    });
  }

  /**
   * Note: this method is not invoked on initialization so returning <boolean> instead of Promise<boolean>
   */
  public isSalesUser(): boolean {
    if (this.primed) {
      return this.userData.userTypeId === CubiqTS.UserType.SALES;
    } else {
      logger.out.warn(
        "WARNING: BfxUserProfileService.isSalesUser(): Invoked before user data is primed!",
      );
      return false;
    }
  }

  public isTraderUser(): boolean {
    if (this.primed) {
      return this.userData.userTypeId === CubiqTS.UserType.TRADER;
    } else {
      logger.out.warn(
        "WARNING: BfxUserProfileService.isSalesUser(): Invoked before user data is primed!",
      );
      return false;
    }
  }

  public isMemberOfSalesGroup(salesId: string): boolean {
    if (this.primed && this.userData) {
      if (this.userData.salesGroupsIds) {
        return this.userData.salesGroupsIds.includes(salesId);
      } else {
        return false;
      }
    } else {
      logger.out.warn(
        "WARNING: BfxUserProfileService.isMemberOfSalesGroup(): Invoked before user data is primed!",
      );
      return false;
    }
  }

  public createProfileSettingObject(
    profileKey: string,
    profileValue: string,
  ): CubiqTS.ProfileSettingImpl {
    let profSetting: CubiqTS.ProfileSettingImpl = new CubiqTS.ProfileSettingImpl();
    profSetting.profileSettingKey = profileKey;
    profSetting.profileSettingValue = profileValue;
    return profSetting;
  }
}
